import { useTranslationWithPrefix } from 'commons/utils';
import { VALID_FILE_TYPES } from 'commons/utils/constants';

export interface FileValidationResult {
  validateFile: (
    file: File,
    maxDocumentSize: number,
  ) => {
    isValid: boolean;
    errorMessage?: string;
  };
}

const useValidateFile = (): FileValidationResult => {
  const { t } = useTranslationWithPrefix('commons.documentUploader');

  const validateFile = (file: File, maxDocumentSize: number) => {
    if (
      !VALID_FILE_TYPES.includes(file.type as (typeof VALID_FILE_TYPES)[number])
    ) {
      return {
        isValid: false,
        errorMessage: t('errors.invalidType'),
      };
    }
    if (file.size > maxDocumentSize || file.size <= 0) {
      return {
        isValid: false,
        errorMessage: t('errors.sizeLimit', {
          maxDocumentSize: maxDocumentSize / 1024 / 1024,
        }),
      };
    }

    return { isValid: true };
  };

  return {
    validateFile,
  };
};

export default useValidateFile;
